import { render, staticRenderFns } from "./main.vue?vue&type=template&id=2bf2f84c&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./less/main.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf2f84c')) {
      api.createRecord('2bf2f84c', component.options)
    } else {
      api.reload('2bf2f84c', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=2bf2f84c&", function () {
      api.rerender('2bf2f84c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/calendarView/main.vue"
export default component.exports